import { ActivityTypesEnum } from "./ActivityTypesEnum";
import { BadgeColorsEnum } from "./BadgeColorsEnum";

export const ActivityMultiSelectListContent = [
    {id: ActivityTypesEnum.Dispensed, name: 'Dispensed', color: BadgeColorsEnum.Red},
    {id: ActivityTypesEnum.Received, name: 'Received', color: BadgeColorsEnum.Green},
    {id: ActivityTypesEnum.Amendment, name: 'Amended', color: BadgeColorsEnum.Blue},
    {id: ActivityTypesEnum.Audit, name: 'Audit', color: BadgeColorsEnum.Purple},
    {id: ActivityTypesEnum.DamagedExpired, name: 'Damaged/Expired', badgeAlias: 'DMG/EX', color: BadgeColorsEnum.Yellow},
    {id: ActivityTypesEnum.LostStolen, name: 'Lost/Stolen', color: BadgeColorsEnum.Yellow},
    {id: ActivityTypesEnum.MovedTo, name: 'Moved To', badgeAlias: 'MVD to', color: BadgeColorsEnum.Pink},
    {id: ActivityTypesEnum.MovedFrom, name: 'Moved From', badgeAlias: 'MVD frm',  color: BadgeColorsEnum.Pink},
    {id: ActivityTypesEnum.Returned, name: 'Returned', color: BadgeColorsEnum.Red},
    {id: ActivityTypesEnum.SoldToProvider, name: 'Sold to Provider', badgeAlias: 'Sold Prov', color: BadgeColorsEnum.Red},
    {id: ActivityTypesEnum.SoldToReverseDistributor, name: 'Sold to Reverse Distributor', badgeAlias: 'Sold Rev Dist.', color: BadgeColorsEnum.Red},
    {id: ActivityTypesEnum.WastedDestroyed, name: 'Wasted/Destroyed', color: BadgeColorsEnum.Red},
  ];